// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league {
    margin: 0;
    display: grid;
    grid-template-areas: "left left center center center center center center center center center center";
    grid-template-columns: repeat(12, 1fr);
    gap: var(--space-and-half);    
}
.league__action-link {
    font-family: Noto Sans;
    font-style: normal;
    font-weight: bold !important;
    font-size: var(--space-half-quarter);
    line-height: var(--space);    
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--primary-very-dark-color);
}

.league-tabs {
    padding-top: var(--space-and-half);
}

.new-tournament__center__header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: var(--space-half);
}


.league .league__center-container .new-tournament__center__header.btn-new {
    justify-content: flex-start;
}

.league .league__center-container .new-tournament__center__header.btn-new .new-tournament__center__header__button {
    margin-left: calc( var( --space-x2 ) + var( --space-half ) ) ;
}

 .tournament-view__new-tournament__header-container {
    background-color: var(--white-color);
    border-top: 3px solid var(--new-background-color);
    border-bottom: 16px solid var(--new-background-color);
}

.tournament-view__new-tournament__header-container .baloa-headline-2 {
    color: var( --primary-very-dark-color );
    padding: 24px 30px;
    border-bottom: 3px solid var(--new-background-color);
}

.tournament-view__new-tournament__header-container .baloa-normal-medium {
    color: var( --basic-gray-color );
    margin-bottom: var( --space-and-half );
}

.new-tournament__center__header__button__spinner-container {
    width: 100%;

}

.new-tournament__center__header__button .button span {
    text-transform: capitalize;
}

.new-tournament__center__header__button__btn-container {
    text-transform: capitalize;
}

.span-newtournament__disabled {
    border: 3px solid var(--primary-very-light-color); 
    border-top: 3px solid var(--basic-green-color);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
    margin: auto;
    

    font-size: var(--font-small);
    font-weight: var(--font-bold);
    font-family: var(--primary-font);
    line-height: var(--space);
    letter-spacing: 0.04em;
    color: var(--primary-very-dark-color);

}

.tournament-view__new-tournament__header-container_edit_component{
    background-color: var( --white-color );
    margin: calc( var( --space-x2 ) + var( --space-quarter ) ) var( --space-x2 );
}

.tournament-view__new-tournament__header-container_title{
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
    flex-direction: row;
    padding-top: var(--space-and-half);
    margin-left: var(--space-x2);
}

.tournament-view__new-tournament__header-container_title .icon-arrow-left{
    font-size: var(--space-and-half);
    cursor: pointer;
    margin-right: var(--space-half);
}

.tournament-view__tournament-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 12px 30px;
    gap: 10px;
}

.tournament-view__tournament-actions .button {
    padding: 12px;
    font-size: 17px;
    line-height: 19px;
    border: 1px solid var(--new-green-color);
    text-transform: capitalize;
}

.new-tournament__center__header__spinner-container {
    width: 160px;
}

@media screen and ( max-width: 1024px ) {
    .league {
        grid-template-areas: "left left center center center center center center center center center center ";
    }
    .league__right-container, .league__left-container {
        display: none;
    }
}
@media screen and ( max-width: 576px ) {
    .league {
        margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/views/TournamentView.styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,aAAa;IACb,sGAAsG;IACtG,sCAAsC;IACtC,0BAA0B;AAC9B;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,4BAA4B;IAC5B,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iCAAiC;AACrC;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6DAA6D;AACjE;;CAEC;IACG,oCAAoC;IACpC,iDAAiD;IACjD,qDAAqD;AACzD;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iDAAiD;IACjD,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,YAAY;;;IAGZ,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,qCAAqC;;AAEzC;;AAEA;IACI,sCAAsC;IACtC,4EAA4E;AAChF;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,uGAAuG;IAC3G;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,SAAS;IACb;AACJ","sourcesContent":[".league {\n    margin: 0;\n    display: grid;\n    grid-template-areas: \"left left center center center center center center center center center center\";\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--space-and-half);    \n}\n.league__action-link {\n    font-family: Noto Sans;\n    font-style: normal;\n    font-weight: bold !important;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);    \n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--primary-very-dark-color);\n}\n\n.league-tabs {\n    padding-top: var(--space-and-half);\n}\n\n.new-tournament__center__header {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-bottom: var(--space-half);\n}\n\n\n.league .league__center-container .new-tournament__center__header.btn-new {\n    justify-content: flex-start;\n}\n\n.league .league__center-container .new-tournament__center__header.btn-new .new-tournament__center__header__button {\n    margin-left: calc( var( --space-x2 ) + var( --space-half ) ) ;\n}\n\n .tournament-view__new-tournament__header-container {\n    background-color: var(--white-color);\n    border-top: 3px solid var(--new-background-color);\n    border-bottom: 16px solid var(--new-background-color);\n}\n\n.tournament-view__new-tournament__header-container .baloa-headline-2 {\n    color: var( --primary-very-dark-color );\n    padding: 24px 30px;\n    border-bottom: 3px solid var(--new-background-color);\n}\n\n.tournament-view__new-tournament__header-container .baloa-normal-medium {\n    color: var( --basic-gray-color );\n    margin-bottom: var( --space-and-half );\n}\n\n.new-tournament__center__header__button__spinner-container {\n    width: 100%;\n\n}\n\n.new-tournament__center__header__button .button span {\n    text-transform: capitalize;\n}\n\n.new-tournament__center__header__button__btn-container {\n    text-transform: capitalize;\n}\n\n.span-newtournament__disabled {\n    border: 3px solid var(--primary-very-light-color); \n    border-top: 3px solid var(--basic-green-color);\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    animation: spin 2s linear infinite;\n    margin: auto;\n    \n\n    font-size: var(--font-small);\n    font-weight: var(--font-bold);\n    font-family: var(--primary-font);\n    line-height: var(--space);\n    letter-spacing: 0.04em;\n    color: var(--primary-very-dark-color);\n\n}\n\n.tournament-view__new-tournament__header-container_edit_component{\n    background-color: var( --white-color );\n    margin: calc( var( --space-x2 ) + var( --space-quarter ) ) var( --space-x2 );\n}\n\n.tournament-view__new-tournament__header-container_title{\n    display: flex;\n    align-items: baseline;\n    justify-content: flex-start;\n    flex-direction: row;\n    padding-top: var(--space-and-half);\n    margin-left: var(--space-x2);\n}\n\n.tournament-view__new-tournament__header-container_title .icon-arrow-left{\n    font-size: var(--space-and-half);\n    cursor: pointer;\n    margin-right: var(--space-half);\n}\n\n.tournament-view__tournament-actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 12px 30px;\n    gap: 10px;\n}\n\n.tournament-view__tournament-actions .button {\n    padding: 12px;\n    font-size: 17px;\n    line-height: 19px;\n    border: 1px solid var(--new-green-color);\n    text-transform: capitalize;\n}\n\n.new-tournament__center__header__spinner-container {\n    width: 160px;\n}\n\n@media screen and ( max-width: 1024px ) {\n    .league {\n        grid-template-areas: \"left left center center center center center center center center center center \";\n    }\n    .league__right-container, .league__left-container {\n        display: none;\n    }\n}\n@media screen and ( max-width: 576px ) {\n    .league {\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
